import * as React from "react";
import * as Glob from "../Globale";
import * as DB from "../components/Dashboards";
import { PortletDraggableOptions } from "../components/Dashboards/Dashboard";

export class Dashboard extends React.Component<Glob.IRouteGlobaleProps, {}> {
    constructor(props: any) {
        super(props);

        this.initDashboardPortlets = this.initDashboardPortlets.bind(this);

        var M = Glob.GetMenu();
        M.Main = "Home";
        M.ID_MenuMain = 0;
        this.props.SetMenu(M);
    }

    private initDashboardPortlets = () => {
        const col1: any = $(this.refs.kt_sortable_portlets_left);
        const col2: any = $(this.refs.kt_sortable_portlets_right);

        col1.sortable({
            ...PortletDraggableOptions,
            connectWith: "#kt_sortable_portlets_right"
        });
        col2.sortable({
            ...PortletDraggableOptions,
            connectWith: "#kt_sortable_portlets_left"
        });

        // @ts-ignore
        window.KTApp.initPortlets();
    };

    public componentDidMount() {
        this.initDashboardPortlets();
    }

    public render() {
        return (
            <div className="kt-portlet DashboardsHome">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-chart-pie"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">Dashboards</h3>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                        <div className="form-group special-group kt-form login-form__group row form-group-padding-height-25 form-group-padding-width-30">
                            <div className={`${Glob.DimensioneCSS(6)} ui-sortable`} id="kt_sortable_portlets_left" ref="kt_sortable_portlets_left">
                                <DB.DashboardAzioniVeloci />
                                <DB.DashboardProdottiEmessi />
                                <DB.DashboardIssued IsIssuedComparison />
                                {/*<DB.DashboardNews />*/}
                                {/*<DashboardIssued />*/}
                            </div>
                            <div className={`${Glob.DimensioneCSS(6)} ui-sortable`} id="kt_sortable_portlets_right" ref="kt_sortable_portlets_right">
                                <DB.DashboardUltimiAggiornamenti History={this.props.history} />
                            </div>
                        </div>
                    </form>
                </div>
                <div className="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/Dashboard.tsx